$(document).ready(function(){

    //////////////////////////////////////////////////////////////////////////
    //				AFFICHAGE / MASQUAGE DES PANELS
    //////////////////////////////////////////////////////////////////////////

    function open_panel(panel_name){
        $('.panel[data-panel="' + panel_name + '"]').addClass('isOpen');

        // On bloque le scroll hors du panel
        $('html').addClass('noScroll');
    }
    function close_panel(){
        $('.panel').removeClass('isOpen');

        // On réactive le scroll hors du panel
        $('html').removeClass('noScroll');

        // On reset les éventuels formulaires qui sont dans le panel seulement si ils ont été envoyés
        $('.panel').find('form:not(:visible)').trigger('reset');

        // On masque les éventuels messages (erreur ou succès)
        $('.panel').find('.alert').hide();

        // On affiche les formulaires qui sont masqués
        $('.panel').find('form:not(:visible)').show();
    }

    ////////////////// OUVRIR LES PANELS //////////////////

    if(window.location.hash) {
        var hash = window.location.hash.substring(1);
        open_panel(hash);
    }

    // Au clic
    $('[data-open-panel]').on('click', function(){
        var $_panel_name = $(this).attr('data-open-panel');
        open_panel($_panel_name);
        return false;
    });

    ////////////////// FERMER LES PANELS //////////////////

    // Clic sur la croix
    $('.panel-fermer').on('click', close_panel);

    // Avec la touche echap
	$(window).on('keydown', function (event) {
		if (event.keyCode == 27) {
			close_panel();
		}
    });

	// Click outside
	$('body').on('click', close_panel);
	$('.panel-container, [data-open-panel]').click(function (event) {
		event.stopPropagation();
	});

});